async function devtricker_proofOfWorkArgon2idWithWorker() {

    if (g_devtricker_argon2Settings.enabled == 'yes') {
        return new Promise((resolve, reject) => {
            const startTime = Date.now();
            const timeout = 60000;
            const salt = devtricker_gen_salt();
            const worker = new Worker(`${g_devtricker_Settings.themeUrl}/workers/pow/powWorker.js`);

            const algorithm = devtricker_getArgonType(g_devtricker_argon2Settings.algorithm);

            console.log(algorithm);
            console.log(argon2);

            const config = {
                type: algorithm,
                hashLength: 32,
                time: g_devtricker_argon2Settings.time_cost,
                mem: g_devtricker_argon2Settings.memory_cost,
                parallelism: g_devtricker_argon2Settings.parallelism,
                pass: '',
                salt: new TextEncoder().encode(salt)
            };

            worker.postMessage({ config, startTime, timeout, salt, trial: 0 });

            worker.onmessage = function (e) {
                if (e.data.success) {
                    resolve(e.data);
                } else {
                    // reject(new Error(e.data.error));
                    resolve(e.data);
                }
                worker.terminate();
            };
        });
    }else{
        return { pow: 'no', pass: '', duration: 0 };
    }
}

function devtricker_getArgonType(apiType) {
    const types = {
        'argon2d': 0,
        'argon2i': 1,
        'argon2id': 2
    };

    return types[apiType];
}


async function devtricker_proofOfWorkArgon2id() {
    const startTime = Date.now();
    const timeout = 60000;

    const salt = devtricker_gen_salt();

    let value = '';
    let trial = 0;
    let hash = '';
    let hashArray;

    const config = {
        type: argon2.ArgonType.Argon2id,
        hashLength: 32,
        time: 2,
        mem: 1024 * 1,
        parallelism: 2,
        pass: value,
        salt: new TextEncoder().encode(salt)
    };

    devtricker_log(null, devtricker_log_level.INFO, "Starting Proof of Work (PoW) generation...");

    while (Date.now() - startTime < timeout) {
        trial++;
        value = salt + '_' + trial;

        try {
            let result = await argon2.hash({
                ...config,
                pass: value,
            });
            hash = result.hashHex;
            hashArray = Array.from(new Uint8Array(result.hash));

            if (hashArray[0] === 0) {
                const endTime = Date.now();
                const duration = (endTime - startTime) / 1000;

                let pow = result.encoded;
                let pass = value;

                devtricker_log(null, devtricker_log_level.INFO, `PoW successfully generated in ${duration.toFixed(2)} seconds`);

                return { pow, pass, duration };
            }
        } catch (error) {
            devtricker_log(error, devtricker_log_level.ERROR, "Error generating Argon2id hash:");
            throw error;
        }
    }

    const errorMessage = `Timeout exceeded while generating PoW (${timeout / 1000} seconds)`;
    devtricker_log(null, devtricker_log_level.ERROR, errorMessage);
    throw new Error(errorMessage);
}

function devtricker_gen_salt() {
    const date = new Date();
    const utcTimestamp = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
        date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    const uniquePart = devtricker_uuidv4();

    return `${uniquePart}_${utcTimestamp}`;
}